<section class="settings-main">
  <div class="settings-main__toolbar">
    <lib-button
      variant="primary"
      type="button"
      prefixIcon="Save"
      [loading]="saving()"
      [disabled]="!hasChanges() || saving()"
      (clicked)="save()"
    >
      Guardar cambios
    </lib-button>
  </div>

  <article class="settings-main__card card-like settings-main__card--role">
    <h2 class="settings-main__card-title">Información de Rol</h2>
    <div class="settings-main__role-row">
      <div>
        <p class="settings-main__label">Tu Rol Actual</p>
        <div class="settings-main__badges">
          <lib-badge
            [text]="roleDisplay().primaryLabel"
            [variant]="isSuperAdmin() ? 'info' : isAdminEmpresa() ? 'success' : 'neutral'"
            size="small"
          />
        </div>
        @for (line of roleDisplay().detailLines; track line) {
          <p class="settings-main__role-detail">{{ line }}</p>
        }
      </div>
      <p class="settings-main__role-hint">{{ roleHint() }}</p>
    </div>
    @if (isSuperAdmin()) {
      <div class="settings-main__capabilities settings-main__capabilities--admin">
        <p class="settings-main__capabilities-title">Capacidades de Super Administrador:</p>
        <ul>
          <li>Gestionar todas las empresas del sistema</li>
          <li>Gestionar todos los usuarios del sistema</li>
          <li>Asignar archivos a cualquier usuario</li>
          <li>Configurar permisos de módulos</li>
          <li>Acceso sin restricciones a todas las empresas</li>
        </ul>
      </div>
    }
    @if (isAdminEmpresa()) {
      <div class="settings-main__capabilities settings-main__capabilities--company">
        <p class="settings-main__capabilities-title">Capacidades de Administrador:</p>
        <ul>
          <li>Gestionar usuarios de tu empresa</li>
          <li>Cambiar emails de usuarios</li>
          <li>Acceso completo a módulos de tu empresa</li>
          <li>Gestionar recursos humanos</li>
          <li>Acceso a módulos avanzados (Legal Hold, Reportes)</li>
        </ul>
      </div>
    }
  </article>

  @if (isSuperAdmin()) {
    <article class="settings-main__card card-like">
      <h2 class="settings-main__card-title">Accesos Rápidos de Administración</h2>
      <p class="settings-main__card-desc">Funciones exclusivas del Super Administrador</p>
      <div class="settings-main__quick-grid">
        <a class="settings-main__quick-link" routerLink="/layout/vault/admin/tenants">
          <span class="settings-main__quick-title">Gestión de Empresas</span>
          <span class="settings-main__quick-desc">Crear y gestionar empresas</span>
        </a>
        <a class="settings-main__quick-link" routerLink="/layout/vault/admin/user">
          <span class="settings-main__quick-title">Gestión de Usuarios</span>
          <span class="settings-main__quick-desc">Gestionar usuarios del sistema</span>
        </a>
        <a class="settings-main__quick-link" routerLink="/layout/vault/admin/module-permissions">
          <span class="settings-main__quick-title">Permisos de Módulos</span>
          <span class="settings-main__quick-desc">Configurar permisos</span>
        </a>
      </div>
    </article>
  }

  <article class="settings-main__card card-like">
    <h2 class="settings-main__card-title">Notificaciones</h2>
    <p class="settings-main__card-desc">Configura cómo y cuándo recibes notificaciones</p>
    <div class="settings-main__toggle-row">
      <div>
        <p class="settings-main__toggle-label">Notificaciones Push</p>
        <p class="settings-main__toggle-hint">Recibe notificaciones en tiempo real en el navegador</p>
      </div>
      <lib-checkbox
        label=""
        [checked]="preferences().push_notifications"
        (checkedChange)="onPushNotificationsToggle($event)"
      />
    </div>
  </article>

  <article class="settings-main__card card-like">
    <h2 class="settings-main__card-title">Visualización</h2>
    <p class="settings-main__card-desc">Personaliza cómo se muestra la información</p>
    <div class="settings-main__field">
      <app-field-label label="Tema" />
      <div class="settings-main__theme-buttons">
        <lib-button
          variant="secondary"
          type="button"
          [class.settings-main__theme-btn--active]="preferences().theme === 'light'"
          (clicked)="setTheme('light')"
        >
          Claro
        </lib-button>
        <lib-button
          variant="secondary"
          type="button"
          [class.settings-main__theme-btn--active]="preferences().theme === 'dark'"
          (clicked)="setTheme('dark')"
        >
          Oscuro
        </lib-button>
        <lib-button
          variant="secondary"
          type="button"
          [class.settings-main__theme-btn--active]="preferences().theme === 'auto'"
          (clicked)="setTheme('auto')"
        >
          Automático
        </lib-button>
      </div>
      <p class="settings-main__field-hint">El tema automático sigue la configuración de tu sistema</p>
    </div>
    <div class="settings-main__field">
      <app-field-label label="Elementos por Página" />
      <lib-select
        label=""
        [options]="itemsPerPageOptions"
        [value]="itemsPerPageStr()"
        (valueChange)="onItemsPerPageChange($event)"
      />
      <p class="settings-main__field-hint">Número de elementos a mostrar en listas y tablas</p>
    </div>
  </article>

  <article class="settings-main__card card-like">
    <h2 class="settings-main__card-title">Idioma</h2>
    <p class="settings-main__card-desc">Idioma de la interfaz</p>
    <div class="settings-main__field">
      <app-field-label label="Idioma" />
      <p class="settings-main__language-value">Español</p>
      <p class="settings-main__field-hint">Por el momento la aplicación está disponible solo en español</p>
    </div>
  </article>

  @if (isSuperAdmin()) {
    <article class="settings-main__card card-like">
      <h2 class="settings-main__card-title">Configuración de Seguridad</h2>
      <p class="settings-main__card-desc">Configuración de seguridad del sistema (solo Super Administrador)</p>
      <div class="settings-main__field">
        <app-field-label label="Tiempo de Expiración de Sesión (minutos)" />
        <lib-input
          label=""
          type="number"
          [value]="sessionTimeoutStr()"
          (valueChange)="onSecurityNumber($event)"
        />
      </div>
    </article>
  }
</section>
